import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PDFDocument } from 'pdf-lib';
import { ENDPOINT } from 'constants/variables';
import { helpHttp } from 'service/HelpHttp';
import { warningErrorAction } from 'actions/ErrorActions';
import ReportTemplateShipping from 'pages/shipping/generatePDF/ReportTemplateShipping';
import ReportTemplateFirst from 'pages/shipping/filterShipping/ShippingFormDIView/ReportTemplateFirst';
import ReportTemplateSecond from 'pages/shipping/filterShipping/ShippingFormDIView/ReportTemplateSecond';

const NOOP = () => {};

const DecaDossierBuilder = ({ row, onDone = NOOP, onReady }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.loginUser.token);
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi.formatnumber);
  const [shipping, setShipping] = useState(null);
  const [shippingPdf, setShippingPdf] = useState(null);
  const [decaPdf, setDecaPdf] = useState(null);
  const [formdi, setFormdi] = useState(null);
  const [formdiPdf, setFormdiPdf] = useState(null);
  const [formdiResolved, setFormdiResolved] = useState(false);
  const completed = useRef(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const shippingData = await helpHttp().get2(
          ENDPOINT, 'shipping/getshippingbyid/', token, row.id
        );
        if (shippingData?.err) throw new Error('shipping');
        if (!cancelled) setShipping(shippingData);

        const decaResponse = await fetch(
          `${ENDPOINT}/deca/documents/public/${row.decaPublicToken}/content`
        );
        if (!decaResponse.ok) throw new Error('deca');
        if (!cancelled) setDecaPdf(await decaResponse.blob());

        if (!row.formdi_id || Number(row.formdi_id) === 0) {
          if (!cancelled) setFormdiResolved(true);
          return;
        }
        const formData = await helpHttp().get8(
          ENDPOINT,
          'form/getpdfformdibyid',
          token,
          row.formdi_id,
          defaulttypesdi
        );
        if (formData?.err) throw new Error('formdi');
        if (formData.isScanned) {
          const fileName = `DI_${formData.numberDI_sheet}.pdf`;
          const scannedPdf = await helpHttp().getfilesupload(
            ENDPOINT, 'pdftos3uploader/downloadfroms3', token, fileName
          );
          if (!scannedPdf || scannedPdf.size === 0) throw new Error('formdi-pdf');
          if (!cancelled) {
            setFormdiPdf(scannedPdf);
            setFormdiResolved(true);
          }
        } else if (!cancelled) {
          setFormdi(formData);
          setFormdiResolved(true);
        }
      } catch (error) {
        if (!cancelled) {
          dispatch(warningErrorAction('No se pudo preparar el expediente DeCA'));
          onDone();
        }
      }
    };
    load();
    return () => { cancelled = true; };
  }, [defaulttypesdi, dispatch, onDone, row, token]);

  useEffect(() => {
    if (completed.current || !decaPdf || !shippingPdf || !formdiResolved
        || (formdi && !formdiPdf)) return;
    completed.current = true;
    const merge = async () => {
      try {
        const dossier = await PDFDocument.create();
        const sources = [decaPdf, formdiPdf, shippingPdf].filter(Boolean);
        for (const source of sources) {
          const pdf = await PDFDocument.load(await source.arrayBuffer());
          const pages = await dossier.copyPages(pdf, pdf.getPageIndices());
          pages.forEach((page) => dossier.addPage(page));
        }
        const bytes = await dossier.save();
        const blob = new Blob([bytes], { type: 'application/pdf' });
        if (onReady) {
          onReady(blob);
        } else {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.click();
          setTimeout(() => URL.revokeObjectURL(url), 60000);
        }
      } catch (error) {
        dispatch(warningErrorAction('No se pudo combinar el expediente DeCA'));
      } finally {
        onDone();
      }
    };
    merge();
  }, [decaPdf, dispatch, formdi, formdiPdf, formdiResolved, onDone, onReady, row.ownshipping_id, shippingPdf]);

  return (
    <>
      {shipping && (
        <ReportTemplateShipping
          dataShipping={shipping}
          setPdfBlob={setShippingPdf}
        />
      )}
      {formdi && !formdiPdf && (defaulttypesdi === 1
        ? <ReportTemplateFirst dataForm={formdi} setPdfBlob={setFormdiPdf} />
        : <ReportTemplateSecond dataForm={formdi} setPdfBlob={setFormdiPdf} />)}
    </>
  );
};

export default DecaDossierBuilder;
